import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { X, Maximize2, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { SemChat, SemHeader } from "./SemChat";

const HIDDEN_PATHS = ["/sem"];

export const SemFloating = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  if (HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed bottom-5 right-5 z-40 group flex items-center gap-2.5 pl-2.5 pr-4 py-2.5 bg-[#0A1128] text-white rounded-md shadow-[0_16px_56px_rgba(10,17,40,0.32)] hover:shadow-[0_24px_72px_rgba(10,17,40,0.4)] transition-all hover:-translate-y-0.5 border border-white/10"
          aria-label="Open SEM chat"
          data-testid="sem-floating-open"
        >
          <span className="relative">
            <span className="w-9 h-9 rounded-md bg-gradient-to-br from-[#F5A623] to-[#E0941A] text-[#0A1128] flex items-center justify-center font-heading font-extrabold text-[11px] tracking-wider">
              SEM
            </span>
            <span className="absolute inset-0 rounded-md bc-pulse-ring" />
          </span>
          <span className="flex flex-col items-start">
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#F5A623] font-bold">{t("sem.bubble_eyebrow", "AI Concierge")}</span>
            <span className="text-[13px] font-semibold leading-tight">{t("sem.bubble_cta")}</span>
          </span>
          <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#16A34A] ring-2 ring-[#0A1128]" />
        </button>
      )}

      {open && (
        <>
          <div className="fixed inset-0 z-40 bg-[#0A1128]/40 backdrop-blur-sm md:hidden" onClick={() => setOpen(false)} />
          <div
            className="fixed bottom-5 right-5 left-5 md:left-auto z-50 md:w-[420px] h-[660px] max-h-[calc(100vh-40px)] bg-white rounded-md shadow-[0_32px_96px_rgba(10,17,40,0.32)] flex flex-col overflow-hidden border border-[#EAE6DF]"
            role="dialog"
            data-testid="sem-floating-panel"
          >
            <div className="relative">
              <SemHeader />
              <div className="absolute top-3 right-3 flex items-center gap-1">
                <Link
                  to="/sem"
                  className="p-1.5 rounded-md hover:bg-[#F3F0EA] text-[#0A1128]/40 hover:text-[#0A1128] transition-colors"
                  onClick={() => setOpen(false)}
                  title={t("sem.expand")}
                  data-testid="sem-floating-expand"
                >
                  <Maximize2 size={14} />
                </Link>
                <button
                  onClick={() => setOpen(false)}
                  className="p-1.5 rounded-md hover:bg-[#F3F0EA] text-[#0A1128]/40 hover:text-[#0A1128] transition-colors"
                  aria-label="Close"
                  data-testid="sem-floating-close"
                >
                  <X size={16} />
                </button>
              </div>
            </div>
            <div className="flex-1 min-h-0">
              <SemChat variant="floating" />
            </div>
          </div>
        </>
      )}
    </>
  );
};
